import { gql } from "@apollo/client";

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPasswordEmail(email: $email) {
      success
    }
  }
`;
